/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolRecommendIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-recommend"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9.15 18.3L14.3 18.3Q14.8 18.3 15.2 18.06Q15.6 17.82 15.8 17.4L17.95 12.4Q18 12.32 18.02 12.2Q18.05 12.07 18.05 12L18.05 11.1Q18.05 10.6 17.68 10.25Q17.3 9.9 16.8 9.9L12.9 9.9L13.47 6.63Q13.53 6.28 13.43 5.96Q13.32 5.65 13.07 5.42L12.25 4.65L7.25 10.1Q7.03 10.32 6.89 10.61Q6.75 10.9 6.75 11.25L6.75 15.95Q6.75 16.93 7.46 17.61Q8.18 18.3 9.15 18.3ZM12 22.8Q9.75 22.8 7.79 21.95Q5.83 21.1 4.36 19.64Q2.9 18.18 2.05 16.21Q1.2 14.25 1.2 12Q1.2 9.75 2.05 7.78Q2.9 5.8 4.36 4.34Q5.83 2.88 7.79 2.04Q9.75 1.2 12 1.2Q14.25 1.2 16.23 2.04Q18.2 2.88 19.66 4.34Q21.13 5.8 21.96 7.78Q22.8 9.75 22.8 12Q22.8 14.25 21.96 16.21Q21.13 18.18 19.66 19.64Q18.2 21.1 16.23 21.95Q14.25 22.8 12 22.8Z" fill={color} />
    </svg>
  );
}
